'use client';

import CWPopup from '@/context/global/components/g00/g00-d00-g007-cw-popup';
import { useTranslations } from 'next-intl';
import React from 'react';

type CWAddQueueProps = {
  isOpen: boolean;
  onClose?: () => void;
  onPlay?: () => void;
  onAddToQueue?: () => void;
};

const CWAddQueue = ({ isOpen, onClose, onPlay, onAddToQueue }: CWAddQueueProps) => {
  const t = useTranslations();

  return (
    <CWPopup
      isOpen={isOpen}
      title={t('AddToQueue.title')}
      leftButtonText={t('AddToQueue.play')}
      rightButtonText={t('AddToQueue.addQueue')}
      onLeftButtonClick={onPlay}
      onRightButtonClick={onAddToQueue}
      onClose={onClose}
      leftButtonProps={{
        variant: 'primary',
        outline: true,
        className:
          ' h-[60px] w-[200px] border-2 border-gray-200 text-white text-[20px] md:text-[24px] font-medium hover:border-ais-green hover:text-ais-green hover:bg-white/10',
      }}
      rightButtonProps={{
        variant: 'primary',
        className:
          ' h-[60px] w-[200px] border-2  text-black text-[20px] md:text-[24px] font-medium hover:border-ais-green hover:text-ais-green hover:bg-ais-green/10',
      }}
      className="max-w-[600px] p-[40px]"
    />
  );
};

export default CWAddQueue;
